/* eslint-disable */
import {Button, createStyles, makeStyles, Theme, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, DialogProps} from "@material-ui/core";
import styles from "./PuiDialog.module.css";
import React from "react";
import ErrorIcon from '@material-ui/icons/Error';

interface PuiDialogProps {
    openDialog: boolean;
    title: string;
    message: string;
    yesLabel: string;
    noLabel: string;
    handleCloseDialog: () => void;
    handleCancel: () => void;
    handleConfirm: () => void;
}

const useStyles = makeStyles((_theme: Theme) =>
    createStyles({
        dialogTitle: {
            padding: "12px 24px 12px 10px"
       },
        dialogContent: {
            marginLeft: "30px",
            padding: "0px 24px",
       },
        dialogActions: {
            marginBottom: "10px",
            marginRight: "10px",
       }
   }),
);

function PuiDialog({
    openDialog,
    title,
    message,
    yesLabel,
    noLabel,
    handleCloseDialog,
    handleCancel,
    handleConfirm
}: PuiDialogProps) {

    const classes = useStyles();
    const closeDialog:DialogProps['onClose'] = (evt,reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
        }
        handleCloseDialog();
    }
    return (
        <Dialog
            disableEscapeKeyDown
            fullWidth={false}
            maxWidth="md"
            open={openDialog}
            onClose={closeDialog}
        >
            <div className={styles.dialogTitle}>
                <ErrorIcon fontSize="large" color="secondary" style={{color: "var(--red)"}} />
                <DialogTitle className={classes.dialogTitle} id="alert-dialog-title">{title}</DialogTitle>
            </div>
            <DialogContent className={classes.dialogContent}>
                <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button size="medium" variant="contained" type="submit" color="secondary" style={{backgroundColor: "var(--red)"}} onClick={handleConfirm} autoFocus>
                    {yesLabel}
                </Button>
                <Button size="medium" variant="outlined" type="submit" color="secondary" onClick={handleCancel}>
                    {noLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default PuiDialog;
